import React from 'react';

const TERMS_TEXT_P1 =
  'Taken in charge in apparently good condition herein at that place of receipt for transport and delivery as mentioned above, unless otherwise stated. The MTO in accordance with the provision contained in the MTD undertakes to perform or to procure the performance of the multi modal transport from the place at which the goods are taken in charge, to the place designated for delivery and assumes responsibility for such transport.';

const TERMS_TEXT_P2 =
  'One of the MTD(s) must be surrendered duly endorsed in exchange for the goods. In witness where of the original MTD all this tenure and date have been signed in the number indicated below one of which being accomplished the other(s) to be void.';

const FALLBACK_LOGO =
  'https://drive.google.com/thumbnail?id=1CkDYisJtzQRy30LWYpOuXpt2NJuTeRqK&sz=w500';

const getCleanLogoUrl = (url) => {
  if (!url) return null;
  const match = url.match(/id=([^&]+)/) || url.match(/\/d\/([^/]+)/);
  if (match && match[1]) {
    return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w500`;
  }
  return url;
};

function extractSize(type) {
  if (!type) return '';
  const match = String(type).match(/(20|40|45)/);
  return match ? `${match[1]}'` : '';
}

function extractType(type) {
  if (!type) return '';
  const t = String(type).toLowerCase();
  if (t.includes('high cube hard top')) return 'HHT';
  if (t.includes('reefer high cube')) return 'RF HC';
  if (t.includes('reefer')) return 'RF';
  if (t.includes('high cube') || t.includes('hc')) return 'HC';
  if (t.includes('open top') || t.includes('open-top') || t.includes('ot')) return 'OT';
  if (t.includes('flat rack') || t.includes('flat-rack') || t.includes('fr')) return 'FR';
  if (t.includes('tank') || t.includes('tk')) return 'TK';
  if (
    t.includes('standard dry') ||
    t.includes('general purpose') ||
    t.includes('dry container') ||
    t.includes('dc') ||
    t.includes('sd') ||
    t.includes('gp')
  ) return 'DC';
  if (t.includes('bulk')) return 'BLK';
  if (t.includes('insulated')) return 'INS';
  if (t.includes('ventilated')) return 'VN';
  return abbrevType(type).replace(/^\d+\s*/, '') || type;
}

function abbrevType(type) {
  if (!type) return '';
  const t = type.toLowerCase();
  const num = t.match(/^(\d+)/)?.[1] || '';
  if (t.includes('high cube hard top'))   return `${num} HHT`;
  if (t.includes('high cube'))            return `${num} HC`;
  if (t.includes('reefer high cube'))     return `${num} RF HC`;
  if (t.includes('reefer'))               return `${num} RF`;
  if (t.includes('open top') || t.includes('open-top')) return `${num} OT`;
  if (t.includes('flat rack') || t.includes('flat-rack')) return `${num} FR`;
  if (t.includes('collapsible flat'))     return `${num} CFR`;
  if (t.includes('tank'))                 return `${num} TK`;
  if (t.includes('platform'))             return `${num} PL`;
  if (t.includes('bulk'))                 return `${num} BLK`;
  if (t.includes('insulated'))            return `${num} INS`;
  if (t.includes('ventilated'))           return `${num} VN`;
  if (t.includes('bin half'))             return `${num} HH`;
  if (t.includes('standard dry') || t.includes('general purpose') || t.includes('dry container')) return num ? `${num} FT` : type;
  if (t.includes('hc') && t.includes('45')) return '45 HC';
  if (t.includes('hc') && t.includes('40')) return '40 HC';
  if (t.includes('hc') && t.includes('20')) return '20 HC';
  if (t.includes('refrig'))               return 'RF';
  if (t.includes('45'))                   return '45 HC';
  if (t.includes('40'))                   return '40 FT';
  if (t.includes('20'))                   return '20 FT';
  return type.length > 14 ? type.substring(0, 12) + '..' : type;
}

function fmtDate(d) {
  if (!d) return '';
  const parts = String(d).split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return d;
}

function fmtOriginalMtds(val) {
  if (val === null || val === undefined || val === '') return '(0) ZERO';
  const str = String(val).trim();
  if (str === '0') return '(0) ZERO';
  if (str === '1') return '(1) ONE';
  if (str === '2') return '(2) TWO';
  if (str === '3') return '(3) THREE';
  return str;
}

const S = {
  page: {
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '8pt',
    color: '#000',
    background: '#fff',
    maxWidth: '210mm',
    margin: '0 auto',
    padding: '4mm 6mm',
    lineHeight: 1.25,
    boxSizing: 'border-box',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    marginTop: '-1px',
  },
  cell: {
    border: '1px solid #000',
    padding: '3px 5px',
    verticalAlign: 'top',
    fontSize: '8pt',
    boxSizing: 'border-box',
  },
  bold: {
    fontWeight: 'bold',
  },
  label: {
    fontWeight: 'bold',
    fontSize: '6.8pt',
    display: 'block',
    marginBottom: '2px',
    textTransform: 'uppercase',
    color: '#222',
    letterSpacing: '0.3px',
  },
  pre: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
};

const SeaMtDocumentPrint = ({ formData, docketNo, companyName, company }) => {
  if (!formData) return null;
  const f = formData;
  const containers = f.containers && f.containers.length > 0 ? f.containers : [{}];
  const displayCompany = company?.name || companyName || 'STAVAN INTERNATIONAL LLP';

  const rawLogoUrl = company?.logo_url || FALLBACK_LOGO;
  const cleanedLogoUrl = getCleanLogoUrl(rawLogoUrl);

  const regOffice =
    company?.address ||
    'B-803 Domain Heights, Nr. Bakeri Sonnet, Opp.Kenyug Apartment, Shyamal Cross Road, Ambawadi, Ahmedabad 380006, Gujarat, India';
  const adminOffice =
    '203, Hemkoot, b/h Lic, Opp. Sanyas ashram, Ashram road, Ahmedabad - 380009, Gujarat, India';
  const phone = company?.phone || '+91-79-40088280, 48994676, 48996287, 48992260';
  const email = company?.email || 'amd@stavan.co.in';
  const website = company?.website || 'http://www.stavan.co.in';
  const mtoRegNo = 'MTO/DGS/2242/AUG/2026';

  // Condition: More than 3 containers OR above space is filled (long description/marks) OR explicitly toggled
  const isAboveSpaceFilled =
    (f.description_of_goods && (f.description_of_goods.length > 280 || f.description_of_goods.split('\n').length > 6)) ||
    (f.marks_and_numbers && (f.marks_and_numbers.length > 180 || f.marks_and_numbers.split('\n').length > 5)) ||
    containers.some(c => c.description && c.description.length > 100);

  const shouldShowBottomTable =
    f.container_layout === 'table' ||
    f.show_container_table === true ||
    (f.container_layout !== 'standard' && f.show_container_table !== false && (containers.length > 3 || isAboveSpaceFilled));

  return (
    <div style={S.page} className="sea-mt-print-root">
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          .sea-mt-print-root, .sea-mt-print-root * { visibility: visible !important; }
          .sea-mt-print-root {
            position: absolute;
            top: 0;
            left: 0;
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
            padding: 4mm 6mm !important;
          }
          @page {
            size: A4 portrait;
            margin: 4mm 6mm;
          }
        }
      `}</style>

      {/* ── ROW 1: Header (Title + MTD/BL Number) ────────────────── */}
      <table style={{ ...S.table, marginTop: 0 }}>
        <tbody>
          <tr>
            <td
              style={{
                ...S.cell,
                width: '54%',
                textAlign: 'center',
                padding: '6px 8px',
                verticalAlign: 'middle',
              }}
            >
              <span
                style={{
                  fontSize: '12.5pt',
                  fontWeight: 'bold',
                  letterSpacing: '1px',
                  display: 'inline-block',
                }}
              >
                MULTI  - MODAL  TRANSPORT  DOCUMENT
              </span>
            </td>
            <td
              style={{
                ...S.cell,
                width: '46%',
                padding: '5px 8px',
                verticalAlign: 'top',
              }}
            >
              <div
                style={{
                  fontSize: '7pt',
                  fontWeight: 'bold',
                  letterSpacing: '0.5px',
                  color: '#111',
                }}
              >
                MTD/BL  NUMBER
              </div>
              <div
                style={{
                  fontSize: '15pt',
                  fontWeight: 'bold',
                  lineHeight: 1.15,
                  marginTop: '1px',
                  letterSpacing: '1px',
                }}
              >
                {f.mtd_bl_number || ''}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── ROW 2: Parties (Left) + Company Branding / Conditions (Right) ─ */}
      <table style={S.table}>
        <tbody>
          <tr>
            {/* LEFT: Consignor / Consignee / Notify Party stacked */}
            <td style={{ ...S.cell, width: '44%', verticalAlign: 'top', padding: '0' }}>
              {/* Consignor / Shipper */}
              <div style={{ borderBottom: '1px solid #000', padding: '4px 6px', minHeight: '60px' }}>
                <span style={S.label}>Consignor  / Shipper</span>
                <div style={{ ...S.pre, fontWeight: 'bold', fontSize: '8pt', lineHeight: 1.25 }}>
                  {f.consignor_shipper || ''}
                </div>
                <div style={{ ...S.pre, fontSize: '7.5pt', marginTop: '2px', lineHeight: 1.25 }}>
                  {f.consignor_address || ''}
                </div>
              </div>

              {/* Consignee (or Order) */}
              <div style={{ borderBottom: '1px solid #000', padding: '4px 6px', minHeight: '60px' }}>
                <span style={S.label}>Consignee  (or Order)</span>
                <div style={{ ...S.pre, fontWeight: 'bold', fontSize: '8pt', lineHeight: 1.25 }}>
                  {f.consignee || ''}
                </div>
                <div style={{ ...S.pre, fontSize: '7.5pt', marginTop: '2px', lineHeight: 1.25 }}>
                  {f.consignee_address || ''}
                </div>
              </div>

              {/* Notify Party */}
              <div style={{ padding: '4px 6px', minHeight: '56px' }}>
                <span style={S.label}>Notify Party</span>
                <div style={{ ...S.pre, fontWeight: 'bold', fontSize: '8pt', lineHeight: 1.25 }}>
                  {f.notify_party || ''}
                </div>
                <div style={{ ...S.pre, fontSize: '7.5pt', marginTop: '2px', lineHeight: 1.25 }}>
                  {f.notify_party_address || ''}
                </div>
              </div>
            </td>

            {/* RIGHT: Company Branding + Addresses + Legal Undertaking */}
            <td style={{ ...S.cell, width: '56%', verticalAlign: 'top', padding: '4px 7px' }}>
              {/* Logo (Right aligned) */}
              {cleanedLogoUrl && (
                <div style={{ textAlign: 'right', marginBottom: '2px' }}>
                  <img
                    src={cleanedLogoUrl}
                    alt={displayCompany}
                    referrerPolicy="no-referrer"
                    crossOrigin="anonymous"
                    style={{ maxHeight: '46px', maxWidth: '160px', objectFit: 'contain' }}
                    onError={(e) => {
                      const match = rawLogoUrl?.match(/id=([^&]+)/) || rawLogoUrl?.match(/\/d\/([^/]+)/);
                      if (match && match[1] && !e.target.dataset.retried) {
                        e.target.dataset.retried = 'true';
                        e.target.src = `https://lh3.googleusercontent.com/d/${match[1]}=w400`;
                      } else {
                        e.target.style.display = 'none';
                      }
                    }}
                  />
                </div>
              )}

              {/* Company Name */}
              <div
                style={{
                  fontSize: '14.5pt',
                  fontWeight: 'bold',
                  fontFamily: 'Arial, sans-serif',
                  letterSpacing: '1px',
                  color: '#000',
                  lineHeight: 1.1,
                  marginBottom: '1px',
                }}
              >
                {displayCompany}
              </div>
              <div style={{ fontSize: '7pt', fontStyle: 'italic', color: '#333', marginBottom: '3px' }}>
                Executor of Commitments
              </div>

              {/* Registered & Admin Offices */}
              <div style={{ fontSize: '6.8pt', lineHeight: 1.22, marginBottom: '2px', color: '#111' }}>
                <strong>Reg.off.:</strong> {regOffice}
              </div>
              <div style={{ fontSize: '6.8pt', lineHeight: 1.22, marginBottom: '2px', color: '#111' }}>
                <strong>Admin Off.:</strong> {adminOffice}
              </div>
              <div style={{ fontSize: '6.8pt', lineHeight: 1.22, marginBottom: '2px', color: '#111' }}>
                <strong>Tel  :</strong> {phone}
              </div>
              <div style={{ fontSize: '6.8pt', lineHeight: 1.22, marginBottom: '3px', color: '#111' }}>
                <strong>Email :</strong> {email}; {website}
              </div>

              {/* MTO Registration */}
              <div style={{ fontSize: '7.2pt', fontWeight: 'bold', marginBottom: '4px', color: '#000' }}>
                MTO  Reg.  No. {mtoRegNo}
              </div>

              {/* Legal Undertaking Paragraphs */}
              <div
                style={{
                  fontSize: '6.4pt',
                  lineHeight: '1.24',
                  color: '#111',
                  textAlign: 'justify',
                  borderTop: '1px solid #ddd',
                  paddingTop: '3px',
                }}
              >
                <p style={{ margin: '0 0 2px 0' }}>{TERMS_TEXT_P1}</p>
                <p style={{ margin: 0 }}>{TERMS_TEXT_P2}</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── ROW 3: Routing 1 (4 Columns) ─────────────────────────── */}
      <table style={S.table}>
        <tbody>
          <tr>
            <td style={{ ...S.cell, width: '25%' }}>
              <span style={S.label}>Place of Acceptance</span>
              <div style={{ fontSize: '7.8pt', fontWeight: 'bold', minHeight: '14px' }}>
                {f.place_of_acceptance || ''}
              </div>
            </td>
            <td style={{ ...S.cell, width: '25%' }}>
              <span style={S.label}>Port of Loading</span>
              <div style={{ fontSize: '7.8pt', fontWeight: 'bold', minHeight: '14px' }}>
                {f.port_of_loading || ''}
              </div>
            </td>
            <td style={{ ...S.cell, width: '25%' }}>
              <span style={S.label}>Modes/means  transport</span>
              <div style={{ fontSize: '7.8pt', fontWeight: 'bold', minHeight: '14px' }}>
                {f.modes_means_transport || 'Sea'}
              </div>
            </td>
            <td style={{ ...S.cell, width: '25%' }}>
              <span style={S.label}>Route/place</span>
              <div style={{ fontSize: '7.8pt', fontWeight: 'bold', minHeight: '14px' }}>
                {f.route_place_of_transport || ''}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── ROW 4: Routing 2 (3 Columns) ─────────────────────────── */}
      <table style={S.table}>
        <tbody>
          <tr>
            <td style={{ ...S.cell, width: '25%' }}>
              <span style={S.label}>Port of Discharge</span>
              <div style={{ fontSize: '7.8pt', fontWeight: 'bold', minHeight: '14px' }}>
                {f.port_of_discharge || ''}
              </div>
            </td>
            <td style={{ ...S.cell, width: '25%' }}>
              <span style={S.label}>Place of Delivery</span>
              <div style={{ fontSize: '7.8pt', fontWeight: 'bold', minHeight: '14px' }}>
                {f.place_of_delivery || ''}
              </div>
            </td>
            <td style={{ ...S.cell, width: '50%' }}>
              <span style={S.label}>Ocean  Vessel  / Voyage</span>
              <div style={{ fontSize: '7.8pt', fontWeight: 'bold', minHeight: '14px' }}>
                {[f.vessel, f.voyage_no].filter(Boolean).join(' / ') || ''}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── ROW 5: Container & Cargo Table ───────────────────────── */}
      <table style={S.table}>
        <thead>
          <tr style={{ background: '#f5f5f5' }}>
            <th style={{ ...S.cell, ...S.bold, width: '16%', fontSize: '7pt', textAlign: 'center' }}>
              Container Nos
            </th>
            <th style={{ ...S.cell, ...S.bold, width: '16%', fontSize: '7pt', textAlign: 'center' }}>
              Marks and Numbers
            </th>
            <th style={{ ...S.cell, ...S.bold, width: '42%', fontSize: '7pt', textAlign: 'center' }}>
              No of Packages,  Kind  of packages,  General Description  of Goods
            </th>
            <th style={{ ...S.cell, ...S.bold, width: '14%', fontSize: '7pt', textAlign: 'center' }}>
              Gross  Wt.(Kgs/MT)
            </th>
            <th style={{ ...S.cell, ...S.bold, width: '12%', fontSize: '7pt', textAlign: 'center' }}>
              Measurement
            </th>
          </tr>
        </thead>
        <tbody>
          {/* Main items row with dynamic height */}
          <tr style={{ minHeight: shouldShowBottomTable ? '130px' : '220px' }}>
            {/* Col 1: Container Nos */}
            <td
              style={{
                ...S.cell,
                width: '16%',
                borderBottom: shouldShowBottomTable ? '1px solid #000' : 'none',
                minHeight: shouldShowBottomTable ? '130px' : '220px',
                height: shouldShowBottomTable ? 'auto' : '220px',
                verticalAlign: 'top',
                padding: '4px 5px',
              }}
            >
              {shouldShowBottomTable && containers.length > 3 ? (
                <div style={{ padding: '2px 0' }}>
                  <div style={{ ...S.bold, fontSize: '7.6pt' }}>
                    TOTAL: {containers.length} CONTAINERS
                  </div>
                  <div style={{ fontSize: '6.8pt', color: '#444', marginTop: '3px' }}>
                    (Details as per table below)
                  </div>
                </div>
              ) : (
                containers.map((c, idx) => {
                  const size = extractSize(c.container_type);
                  const type = extractType(c.container_type);
                  const sizeType = [size, type].filter(Boolean).join(' ');
                  const displayNo = [c.container_no, sizeType].filter(Boolean).join(' /');
                  return (
                    <div key={idx} style={{ marginBottom: idx < containers.length - 1 ? '8px' : '0' }}>
                      <div style={{ fontSize: '6.8pt', color: '#333' }}>CONTAINER NO.:</div>
                      {displayNo && <div style={{ ...S.bold, fontSize: '7.6pt' }}>{displayNo}</div>}
                      {c.line_seal_no && (
                        <div style={{ fontSize: '6.8pt', marginTop: '2px' }}>
                          <span style={S.bold}>CARRIER'S SEAL NO.:</span><br />{c.line_seal_no}
                        </div>
                      )}
                      {c.custom_seal_no && (
                        <div style={{ fontSize: '6.8pt', marginTop: '1px' }}>
                          <span style={S.bold}>SHIPPER'S SEAL NO.:</span><br />{c.custom_seal_no}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </td>

            {/* Col 2: Marks and Numbers */}
            <td
              style={{
                ...S.cell,
                width: '16%',
                borderBottom: shouldShowBottomTable ? '1px solid #000' : 'none',
                minHeight: shouldShowBottomTable ? '130px' : '220px',
                height: shouldShowBottomTable ? 'auto' : '220px',
                verticalAlign: 'top',
                padding: '4px 5px',
              }}
            >
              <div style={{ ...S.pre, fontSize: '7.5pt', lineHeight: 1.25 }}>
                {f.marks_and_numbers || ''}
              </div>
            </td>

            {/* Col 3: Goods Description & Packages */}
            <td
              style={{
                ...S.cell,
                width: '42%',
                borderBottom: shouldShowBottomTable ? '1px solid #000' : 'none',
                minHeight: shouldShowBottomTable ? '130px' : '220px',
                height: shouldShowBottomTable ? 'auto' : '220px',
                verticalAlign: 'top',
                padding: '4px 6px',
              }}
            >
              {f.description_of_goods && (
                <div style={{ ...S.pre, fontSize: '7.5pt', lineHeight: 1.25, marginBottom: '6px' }}>
                  {f.description_of_goods}
                </div>
              )}
              {containers.map((c, idx) => {
                if (!c.description && !c.packages) return null;
                return (
                  <div key={idx} style={{ fontSize: '7.5pt', marginTop: '3px' }}>
                    {c.packages && !shouldShowBottomTable && (
                      <div>
                        <span style={S.bold}>PACKAGES:</span> {c.packages}
                      </div>
                    )}
                    {c.description && c.description !== f.description_of_goods && (
                      <div style={{ ...S.pre, marginTop: '2px' }}>{c.description}</div>
                    )}
                  </div>
                );
              })}
            </td>

            {/* Col 4: Gross Wt */}
            <td
              style={{
                ...S.cell,
                width: '14%',
                borderBottom: shouldShowBottomTable ? '1px solid #000' : 'none',
                minHeight: shouldShowBottomTable ? '130px' : '220px',
                height: shouldShowBottomTable ? 'auto' : '220px',
                verticalAlign: 'top',
                padding: '4px 5px',
                textAlign: 'center',
              }}
            >
              {!shouldShowBottomTable ? (
                containers.map((c, idx) => (
                  <div key={idx} style={{ marginBottom: '6px', fontSize: '7.5pt' }}>
                    {c.gross_weight && (
                      <div>
                        <span style={S.bold}>GR WT:</span> {c.gross_weight}
                      </div>
                    )}
                    {c.net_weight && (
                      <div style={{ marginTop: '2px' }}>
                        <span style={S.bold}>NET WT:</span> {c.net_weight}
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div style={{ fontSize: '7.5pt' }}>
                  {containers[0]?.gross_weight && (
                    <div>
                      <span style={S.bold}>GR WT:</span> {containers[0].gross_weight}
                    </div>
                  )}
                  {containers[0]?.net_weight && (
                    <div style={{ marginTop: '2px' }}>
                      <span style={S.bold}>NET WT:</span> {containers[0].net_weight}
                    </div>
                  )}
                </div>
              )}
            </td>

            {/* Col 5: Measurement */}
            <td
              style={{
                ...S.cell,
                width: '12%',
                borderBottom: shouldShowBottomTable ? '1px solid #000' : 'none',
                minHeight: shouldShowBottomTable ? '130px' : '220px',
                height: shouldShowBottomTable ? 'auto' : '220px',
                verticalAlign: 'top',
                padding: '4px 5px',
                textAlign: 'center',
                fontSize: '7.8pt',
                fontWeight: 'bold',
              }}
            >
              {f.measurement || ''}
            </td>
          </tr>

          {/* ── Circled Container Table at bottom of goods area ── */}
          {shouldShowBottomTable && (
            <tr>
              <td
                colSpan={5}
                style={{
                  padding: '0',
                  border: '1px solid #000',
                  borderTop: '1px solid #000',
                  borderBottom: 'none',
                  background: '#fff',
                }}
              >
                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                  <thead>
                    <tr style={{ background: '#fff', borderBottom: '1px solid #000' }}>
                      <th style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.4pt', textAlign: 'left', width: '23%', borderRight: '1px solid #000', padding: '3px 5px' }}>
                        Container No
                      </th>
                      <th style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.4pt', textAlign: 'center', width: '7%', borderRight: '1px solid #000', padding: '3px 2px' }}>
                        Size
                      </th>
                      <th style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.4pt', textAlign: 'center', width: '7%', borderRight: '1px solid #000', padding: '3px 2px' }}>
                        Type
                      </th>
                      <th style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.4pt', textAlign: 'left', width: '16%', borderRight: '1px solid #000', padding: '3px 4px' }}>
                        Cus Seal
                      </th>
                      <th style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.4pt', textAlign: 'left', width: '15%', borderRight: '1px solid #000', padding: '3px 4px' }}>
                        Seal
                      </th>
                      <th style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.4pt', textAlign: 'right', width: '11%', borderRight: '1px solid #000', padding: '3px 5px' }}>
                        Net Wt.
                      </th>
                      <th style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.4pt', textAlign: 'right', width: '11%', borderRight: '1px solid #000', padding: '3px 5px' }}>
                        Gross Wt.
                      </th>
                      <th style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.4pt', textAlign: 'center', width: '8%', borderRight: '1px solid #000', padding: '3px 2px' }}>
                        CBM
                      </th>
                      <th style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.4pt', textAlign: 'center', width: '8%', padding: '3px 2px' }}>
                        PKG
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {containers.map((c, idx) => {
                      const size = extractSize(c.container_type);
                      const type = extractType(c.container_type);
                      const sizeType = [size, type].filter(Boolean).join(' ');
                      const fullNo = [c.container_no, sizeType].filter(Boolean).join(' /');
                      const isLast = idx === containers.length - 1;
                      return (
                        <tr key={idx} style={{ borderBottom: isLast ? 'none' : '1px solid #000' }}>
                          <td style={{ ...S.cell, fontWeight: 'bold', fontSize: '7.2pt', textAlign: 'left', borderRight: '1px solid #000', padding: '3px 5px' }}>
                            {fullNo || c.container_no || ''}
                          </td>
                          <td style={{ ...S.cell, fontSize: '7.2pt', textAlign: 'center', borderRight: '1px solid #000', padding: '3px 2px' }}>
                            {size}
                          </td>
                          <td style={{ ...S.cell, fontSize: '7.2pt', textAlign: 'center', borderRight: '1px solid #000', padding: '3px 2px' }}>
                            {type}
                          </td>
                          <td style={{ ...S.cell, fontSize: '7.2pt', textAlign: 'left', borderRight: '1px solid #000', padding: '3px 4px' }}>
                            {c.custom_seal_no || ''}
                          </td>
                          <td style={{ ...S.cell, fontSize: '7.2pt', textAlign: 'left', borderRight: '1px solid #000', padding: '3px 4px' }}>
                            {c.line_seal_no || ''}
                          </td>
                          <td style={{ ...S.cell, fontSize: '7.2pt', textAlign: 'right', borderRight: '1px solid #000', padding: '3px 5px' }}>
                            {c.net_weight || ''}
                          </td>
                          <td style={{ ...S.cell, fontSize: '7.2pt', textAlign: 'right', borderRight: '1px solid #000', padding: '3px 5px' }}>
                            {c.gross_weight || ''}
                          </td>
                          <td style={{ ...S.cell, fontSize: '7.2pt', textAlign: 'center', borderRight: '1px solid #000', padding: '3px 2px' }}>
                            {c.measurement || (idx === 0 ? f.measurement : '')}
                          </td>
                          <td style={{ ...S.cell, fontSize: '7.2pt', textAlign: 'center', fontWeight: 'bold', padding: '3px 2px' }}>
                            {c.packages || ''}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </td>
            </tr>
          )}

          {/* Bottom strip of Goods area: Select Type + Shipped On Board */}
          <tr>
            <td
              colSpan={2}
              style={{
                ...S.cell,
                borderTop: '1px solid #000',
                verticalAlign: 'middle',
                textAlign: 'center',
                padding: '3px 5px',
              }}
            >
              {f.select_type && (
                <div style={{ fontWeight: 'bold', fontSize: '8.5pt' }}>
                  {f.select_type.toUpperCase()}
                </div>
              )}
              {f.fcl_lcl && (
                <div style={{ fontSize: '7.5pt', marginTop: '1px' }}>
                  {f.fcl_lcl} / {f.fcl_lcl} CY CY
                </div>
              )}
            </td>
            <td
              colSpan={3}
              style={{
                ...S.cell,
                borderTop: '1px solid #000',
                fontSize: '7.5pt',
                padding: '3px 6px',
                verticalAlign: 'middle',
              }}
            >
              <div style={{ fontWeight: 'bold' }}>
                SHIPPED ON BOARD DATE: {fmtDate(f.shipped_on_board_date)}
              </div>
              <div style={{ fontSize: '6.8pt', marginTop: '1px', fontStyle: 'italic', color: '#333' }}>
                PARTICULAR ABOVE FURNISHED BY CONSIGNOR/CONSIGNEE
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── ROW 6: Freight / MTD Count / Place & Date of Issue ─────── */}
      <table style={S.table}>
        <tbody>
          <tr>
            <td style={{ ...S.cell, width: '18%' }}>
              <span style={S.label}>Freight  Amount</span>
              <div style={{ ...S.bold, fontSize: '8pt' }}>{f.freight_amount || 'COLLECT'}</div>
            </td>
            <td style={{ ...S.cell, width: '24%' }}>
              <span style={S.label}>Freight  payable  at</span>
              <div style={{ ...S.bold, fontSize: '8pt' }}>
                {f.freight_payable_at || 'DESTINATION'}
              </div>
            </td>
            <td style={{ ...S.cell, width: '22%' }}>
              <span style={S.label}>Number  of Original  MTD(s)</span>
              <div style={{ ...S.bold, fontSize: '8pt', textAlign: 'center' }}>
                {fmtOriginalMtds(f.no_of_original_mtds)}
              </div>
            </td>
            <td style={{ ...S.cell, width: '36%' }}>
              <span style={S.label}>Place  and Date  of Issue :</span>
              <div style={{ ...S.bold, fontSize: '8pt' }}>
                {[f.place_of_issue, f.date_of_issue ? `DT : ${fmtDate(f.date_of_issue)}` : '']
                  .filter(Boolean)
                  .join(' ')}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── ROW 7: Other Particulars + Carrier Signature ─────────── */}
      <table style={S.table}>
        <tbody>
          <tr>
            <td
              style={{
                ...S.cell,
                width: '56%',
                verticalAlign: 'top',
                minHeight: '75px',
                padding: '4px 6px',
              }}
            >
              <span style={{ ...S.bold, fontSize: '7.5pt' }}>Other  Particulars  (if any): -</span>
              {f.agent_detail && (
                <div style={{ ...S.pre, marginTop: '3px', fontSize: '7.5pt', lineHeight: 1.25 }}>
                  {f.agent_detail}
                </div>
              )}
            </td>
            <td
              style={{
                ...S.cell,
                width: '44%',
                verticalAlign: 'top',
                minHeight: '75px',
                padding: '4px 6px',
              }}
            >
              <div
                style={{
                  ...S.bold,
                  fontSize: '8.5pt',
                  marginBottom: '38px',
                  textAlign: 'right',
                }}
              >
                For {displayCompany}
              </div>
              <div
                style={{
                  borderTop: '1px solid #000',
                  paddingTop: '3px',
                  fontSize: '7.2pt',
                  textAlign: 'center',
                }}
              >
                (Authorized  Signatory)  As  Agent  For  Carrier
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── ROW 8: Footer Terms Notice ───────────────────────────── */}
      <table style={S.table}>
        <tbody>
          <tr>
            <td
              style={{
                ...S.cell,
                textAlign: 'center',
                fontSize: '7.2pt',
                fontWeight: 'bold',
                padding: '3px 5px',
                letterSpacing: '0.2px',
              }}
            >
              Weight  and measurement of container  not to be included(TERMS  CONTINUED  ON BACK HEREOF)
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SeaMtDocumentPrint;
